/* ==========================================================================
   NS Search Drawer
   Opens from the header search icon. Shows suggestion tags, category circles
   and recommendations until the shopper types, then swaps in live predictive
   results from Shopify's /search/suggest endpoint.
   ========================================================================== */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-ns-search-drawer]');
  if (!drawer) return;

  var scrim = document.querySelector('[data-ns-scrim]');
  var input = drawer.querySelector('[data-ns-search-input]');
  var clearBtn = drawer.querySelector('[data-ns-search-clear]');
  var results = drawer.querySelector('[data-ns-search-results]');
  var defaults = drawer.querySelector('[data-ns-search-default]');
  var lastFocus = null;
  var debounce;
  var controller;
  var RESULT_LIMIT = 10;

  function open(e) {
    if (e) e.preventDefault();
    lastFocus = document.activeElement;
    drawer.classList.add('ns-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('ns-open');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-ns-search-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    setTimeout(function () {
      if (input) input.focus();
    }, 320);
  }

  function close() {
    drawer.classList.remove('ns-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('ns-open');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-ns-search-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showDefaults() {
    if (results) {
      results.hidden = true;
      results.innerHTML = '';
    }
    if (defaults) defaults.hidden = false;
  }

  /* /search/suggest.json returns prices as a decimal string already in the shop
     currency ("1200.00"), NOT in cents like /cart.js does. Dividing by 100 here
     turned Rs. 1,200 into Rs. 12. Parse the string and format it as-is. */
  function money(value) {
    var amount = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    if (!isFinite(amount)) return '';

    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'INR';

    try {
      return amount.toLocaleString('en-IN', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    } catch (e) {
      return '₹' + Math.round(amount).toLocaleString('en-IN');
    }
  }

  /* Products whose variants span a range read "From Rs. X" rather than quoting
     the cheapest variant as if it were the price of the product. */
  function priceLabel(p) {
    var min = money(p.price_min != null ? p.price_min : p.price);
    if (p.price_min != null && p.price_max != null && p.price_min !== p.price_max) {
      return 'From ' + min;
    }
    return min;
  }

  function render(products, query) {
    if (!results) return;
    if (defaults) defaults.hidden = true;
    results.hidden = false;

    /* Predictive search and the full search page are different engines: the
       drawer returns nothing for "Hola Studs" while /search finds 23 matches.
       Never dead-end the shopper here — always offer the full search page. */
    if (!products.length) {
      results.innerHTML =
        '<div class="ns-sd__group"><p class="ns-sd__empty">No quick matches for &ldquo;' +
        escapeHtml(query) +
        '&rdquo;.</p>' +
        '<a class="ns-sd__all" href="' + searchPageUrl(query) + '">' +
        'Search the full store for &ldquo;' + escapeHtml(query) + '&rdquo;' +
        '</a></div>';
      return;
    }

    var cards = products
      .map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        return (
          '<a class="ns-sdp" href="' + p.url + '">' +
          '<span class="ns-sdp__pic">' +
          (img ? '<img src="' + img + '&width=300" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="ns-sdp__name">' + escapeHtml(p.title) + '</span>' +
          '<span class="ns-sdp__price">' + priceLabel(p) + '</span>' +
          '</a>'
        );
      })
      .join('');

    /* The drawer can only ever show RESULT_LIMIT products, so a term like "ring"
       (173 results) looked like the store carried eight. This link is the route
       to the full search page, which paginates every match. */
    var viewAll =
      '<a class="ns-sd__all" href="' + searchPageUrl(query) + '">' +
      'View all results for &ldquo;' + escapeHtml(query) + '&rdquo;' +
      '</a>';

    results.innerHTML =
      '<div class="ns-sd__group"><div class="ns-sd__label">Results</div>' +
      '<div class="ns-sd__recs">' + cards + '</div>' + viewAll + '</div>';
  }

  function searchPageUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function search(q) {
    if (controller) controller.abort();
    controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

    /* 10 is the maximum Shopify predictive search accepts per resource type.
       At 8, out-of-stock products (pushed last by unavailable_products) were
       cut off before they could ever be shown. */
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + RESULT_LIMIT +
      '&resources[options][unavailable_products]=last';

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var products =
          data && data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products
            : [];
        render(products, q);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        showDefaults();
      });
  }

  document.querySelectorAll('[data-ns-search-open]').forEach(function (btn) {
    btn.addEventListener('click', open);
  });
  drawer.querySelectorAll('[data-ns-search-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  if (scrim) scrim.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('ns-open')) close();
  });

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      clearTimeout(debounce);
      if (q.length < 2) {
        showDefaults();
        return;
      }
      debounce = setTimeout(function () {
        search(q);
      }, 220);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      showDefaults();
      input.focus();
    });
  }
})();
